const LOCATION_SEARCH_REGEX = /puan|filtreler|siralama|markalar|kategori|sayfa|q/g;
const BRAND_AND_CATEGORY_REGEX = /\/([^/]+)\/([^/]+)-c-(\d+)/;


function isAppliedFilter(locationSearch) {
  return locationSearch?.search(LOCATION_SEARCH_REGEX) > 0;
}

function isAppliedBrand(urlPath) {
  const match = urlPath?.match(BRAND_AND_CATEGORY_REGEX);
  if (match) {
    const brand = match?.[1];
    if(brand){
      return true;
    }
  }
  return false;
}


export const getIsAppliedFilter = () => {
  if (process.env.BROWSER && window) {
    return isAppliedBrand(window?.location?.pathname) || isAppliedFilter(window?.location?.search);
  }
  return false;
};


export const getIsAppliedFilterForServer = (url) => {
  return isAppliedBrand(url) || isAppliedFilter(url);
};

export const checkSimilarProductsWidgetVisibilty = ({
  isCollectionPage = false,
  appliedFilters = []
}) => {
  const hasPhoneModelFilter = appliedFilters?.find(
    filter => filter?.key === 'telefonmodeli' || filter?.id === 'telefonmodeli'
  ) !== undefined

  return !(isCollectionPage && hasPhoneModelFilter)
}
